// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconAlphaR = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M13.358 12.884l2.898 3.626V17h-1.694l-3.066-3.948H10.36V17H8.625V6.948h3.262c1.022 0 1.974.084 2.717.588.784.518 1.19 1.33 1.19 2.366 0 1.82-1.162 2.688-2.437 2.982m-1.47-4.438H10.36v3.108h1.526c1.33 0 2.17-.462 2.17-1.582 0-1.148-.84-1.526-2.17-1.526"
    />,
    <path
      fillRule="evenodd"
      d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1116 0 8 8 0 01-16 0"
    />
  );
export default SvgIconAlphaR;
